import { combineReducers } from "redux";

// Authentication
import authentication from "./authentication/reducer";
import settings from "./settings/reducer";
import contactTypes from "./contactTypes/reducer";
import applications from "./applications/reducer";
import categories from "./categories/reducer";
import subscriptions from "./subscriptions/reducer";
import themes from "./themes/reducer";
import coupons from "./coupons/reducer";
import payments from "./payments/reducer";
import employees from "./employees/reducer";
import data from "./data/reducer";
import paymentMethods from "./paymentMethods/reducer";
import demoStores from "./demoStores/reducer";
import webhooks from "./webhooks/reducer";
import customPlans from "./applications/customPlans/reducer";
import reviews from "./applications/reviews/reducer";

const rootReducer = combineReducers({
  authentication,
  contactTypes,
  settings,
  applications,
  categories,
  subscriptions,
  themes,
  coupons,
  payments,
  employees,
  data,
  paymentMethods,
  demoStores,
  webhooks,
  customPlans,
  reviews,
});

export default rootReducer;
